import { setupDevtoolsPlugin } from '@vue/devtools-api';

export default {
    install (app: any) {
        setupDevtoolsPlugin({
            id: 'be-better-devtools',
            label: 'BE-Better Devtools',
            settings: {
                only: {
                    label: 'Auto open component names (use ,)',
                    type: 'text',
                    defaultValue: 'RouterView,RouteGroup,VMain',
                },
            },
            app
        }, api => {
            api.on.visitComponentTree((payload, context) => {
                const node = payload.treeNode;
                if ((api.getSettings().only as string).split(',').includes(node.name)) {
                    node.autoOpen = true;
                } else {
                    node.autoOpen = false;
                }
            });
        });
    }
}
